var React = require('react');
var _ = require('lodash');
var Item = require('./item');
var cx = require('classnames');

class Group extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      showChildren: false
    }
  }

  /**
   * Returns the currently selected children
   * @returns {Array}
   */
  selectedChildren () {
    return _.select(this.props.group.children, {
      selected : true
    });
  }

  /**
   * Does the group have any selected children?
   * @returns {boolean}
   */
  anyChildrenSelected () {
    return this.selectedChildren().length > 0;
  }

  /**
   * Are all the group's children selected?
   * @returns {boolean}
   */
  allChildrenSelected () {
    var selectedChildrenCount = this.selectedChildren().length;
    return selectedChildrenCount === this.props.group.children.length;
  }

  /**
   * Toggle the display of the children
   */
  toggleChildrenDisplay () {
    this.setState({ showChildren: !this.state.showChildren });
  }

  /**
   * Toggle all chilrens' selected state.
   * @param event
   */
  toggleSelectedChildren (event) {
    event.preventDefault();
    event.stopPropagation();
    var newValue = !this.allChildrenSelected();
    this.props.toggleItems(this.props.group.children, newValue);
  }

  componentDidMount() {
    this.setState({ showChildren: this.props.showChildren })
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ showChildren: nextProps.showChildren || nextProps.group.children.some((el) => el.selected)});
  }

  children () {
    if (this.state.showChildren) {
      return this.props.group.children.map(function (item, index) {
        return <Item className="child" item={item} toggle={this.props.toggleItems} key={index} />;
      }.bind(this));
    }
  }

  render () {
    var classes = ['grouped-item', 'border-color', 'group-parent'];
    let visible = this.anyChildrenSelected() || this.state.showChildren;
    if (visible) {
      classes.push('active', 'open')
    }
    return (
      <div>
        <div className={cx(classes)} onClick={this.toggleChildrenDisplay.bind(this)}>
          <i className={cx('color-secondary', 'fa', (this.state.showChildren ? 'fa-minus' : 'fa-plus'))}></i>
          <span>{this.props.group.name}</span> <i className="fa fa-ellipsis-v children-selected" style={{ display: visible ? null : 'none' }}></i>
          <a href="#"
             className="toggle-children pull-right color-secondary"
             onClick={this.toggleSelectedChildren.bind(this)}>
              { (!this.allChildrenSelected()) ? 'Check' : 'Uncheck' } All
          </a>
        </div>
        {this.children()}
      </div>
    )
  }
}

module.exports = Group;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/items_selector/group.jsx